import NumberBox from "devextreme-react/number-box";
import { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadKhoanNopStart } from "../../../state/actions/khoanNopActions";
import {
  XIcon,
  CheckIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "@primer/octicons-react";
import { Box, Checkbox, IconButton } from "@primer/react";

import { AddKhoanNopModalRespone } from "..";
import { mucPhaiThuChiTietApi } from "../../../api/mucPhaiThuChiTietApi";
import { mucThuPhiApi } from "../../../api/mucThuPhiApi";
import CmbHinhThucNopBom from "../../../components/combobox-hinh-thuc-nop-bom";
import { NamHocTruongKhoiHeFilter } from "../../../models/namHocTruongKhoiHeFilter";
import { sf_hinhthucnopbom } from "../../../models/response/category/sf_hinhthucnopbom";
import { RootState } from "../../../state/reducers";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import TextInput from "../../../components/ui/text-input";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { khoanNopGroupApi } from "../../../api/khoanNopGroupApi";
import SelectBoxMultipleKhomKhoanNop from "../../selectbox-nhomkhoannop/SelectBoxMultipleKhomKhoanNop";
import { DefaultPopup } from "../../modal";
import { formatVND } from "../../../utils/formatVND";

type AddKhoanNopFromKhoanNopProps = {
  sf_khoannop_ids_added?: number[];
  onSelected: (data: AddKhoanNopModalRespone) => void;
  onCancel: () => void;
  isSaving: boolean;
  filter: NamHocTruongKhoiHeFilter;
  nam_nhap_hoc?: string;
  ts_hocsinh_id: number;
  sf_hinhthucnopbom_ids?: string;
  sf_mucphaithu_id?: number;
};
export const AddKhoanNopFromKhoanNop = (
  props: AddKhoanNopFromKhoanNopProps
) => {
  const { dm_coso_id } = useSelector((state: RootState) => state.common);
  const { sf_nhomkhoannops } = useSelector((x: RootState) => x.nhomKhoanNop);
  const [sf_mucthuphi_selected_ids, set_sf_mucthuphi_selected_ids] = useState<
    number[]
  >([]);
  const [is_tinh_mien_giam] = useState<boolean>(true);
  const [sf_mucthuphi_datasource, set_sf_mucthuphi_datasource] = useState<
    any[]
  >([]);
  const [hinhThucNopBoms, setHinhThucNopBoms] = useState<sf_hinhthucnopbom[]>(
    []
  );
  const [selectedNhomKhoanNopIds, setSelectedNhomKhoanNopIds] = useState<
    number[]
  >([]);
  const [selectedNhomKhoanNopNames, setSelectedNhomKhoanNopNames] = useState<
    string[]
  >([]);
  const [khoanDaNops, setKhoanDaNops] = useState<number[]>([]);
  const [khoanNopDichVuIds, setKhoanNopDichVuIds] = useState<number[]>([]);
  const [summary, setSummary] = useState<number>();
  const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(
    new Map()
  );
  const [originalDataSource, setOriginalDataSource] = useState<any[]>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadKhoanNopStart());
  }, [dispatch]);

  const handleReloadKhoanNopDichVu = useCallback(async () => {
    const request = {
      dm_coso_id: dm_coso_id,
      ts_hocsinh_id: props.ts_hocsinh_id,
      nam_hoc: props.filter.nam_hoc,
    };
    const res = await khoanNopGroupApi.select_dichvu_by_hs(request);
    if (res.is_success) {
      const khoanNopIds = res.data
        .filter(
          (x: any) =>
            x.sf_saleset_register_dichvu_status_id === 1 ||
            x.sf_saleset_register_dichvu_status_id === 2
        )
        .map((x: any) => x.sf_khoannop_group_id);
      setKhoanNopDichVuIds(khoanNopIds);
    }
  }, [dm_coso_id, props.ts_hocsinh_id, props.filter.nam_hoc]);

  useEffect(() => {
    handleReloadKhoanNopDichVu();
  }, [handleReloadKhoanNopDichVu]);

  // Filter data source khi khoanDaNops, khoanNopDichVuIds hoặc hinhThucNopBoms thay đổi
  // Chỉ filter lại khi danh sách IDs thay đổi, không phải khi giá trị trong items thay đổi
  const filteredDataSource = useMemo(() => {
    if (originalDataSource.length === 0) return [];

    let filterData = originalDataSource.filter(
      (x: any) => !khoanDaNops || !khoanDaNops.includes(x.sf_khoannop_id)
    );

    // Filter theo hinhThucNopBoms nếu có
    if (
      hinhThucNopBoms.length > 0 &&
      hinhThucNopBoms[0] !== undefined &&
      hinhThucNopBoms[0] != null
    ) {
      const sf_htnb_ids = hinhThucNopBoms
        .filter((obj) => obj && obj.id)
        .map((obj: { id: number }) => obj.id);
      filterData = filterData.filter((x: any) =>
        x.sf_hinhthucnopbom_ids
          ?.split(",")
          .map((id: string) => parseInt(id, 10))
          .some((id: number) => sf_htnb_ids.includes(id))
      );
    }

    // Filter theo nhóm khoản nộp
    if (selectedNhomKhoanNopIds.length > 0) {
      const selectedNames =
        selectedNhomKhoanNopNames && selectedNhomKhoanNopNames.length > 0
          ? selectedNhomKhoanNopNames
          : [];
      filterData = filterData.filter((x: any) =>
        selectedNames.includes(x.nhom_khoan_nop)
      );
    }

    if (khoanNopDichVuIds.length > 0) {
      filterData = filterData.filter(
        (x: any) =>
          x.sf_loaikhoannop_id === 4 ||
          !x.is_dichvu ||
          khoanNopDichVuIds.includes(x.sf_khoannop_group_id)
      );
    } else {
      filterData = filterData.filter((x: any) => !x.is_dichvu);
    }
    return filterData;
  }, [
    selectedNhomKhoanNopIds,
    selectedNhomKhoanNopNames,
    originalDataSource,
    khoanDaNops,
    khoanNopDichVuIds,
    hinhThucNopBoms,
  ]);

  // Memoize filteredDataSource IDs để detect thay đổi về cấu trúc
  const filteredDataSourceIds = useMemo(() => {
    return filteredDataSource
      .map((x) => x.id)
      .sort()
      .join(",");
  }, [filteredDataSource]);

  // Chỉ update sf_mucthuphi_datasource khi filteredDataSource thay đổi về mặt cấu trúc (thêm/xóa items)
  useEffect(() => {
    set_sf_mucthuphi_datasource((prev) => {
      const prevIds = prev
        .map((x) => x.id)
        .sort()
        .join(",");

      if (
        prevIds === filteredDataSourceIds &&
        prev.length === filteredDataSource.length
      ) {
        return prev; // Không thay đổi, giữ nguyên reference
      }

      // Merge với dữ liệu hiện tại để giữ lại các giá trị đã chỉnh sửa
      const merged = filteredDataSource.map((newItem) => {
        const existing = prev.find((x) => x.id === newItem.id);
        if (existing) {
          return {
            ...newItem,
            so_tien_phai_nop: existing.so_tien_phai_nop,
            ghi_chu: existing.ghi_chu,
          };
        }
        return newItem;
      });
      return merged;
    });
  }, [filteredDataSourceIds]);

  const filterKey = useMemo(() => {
    return `${props.filter.dm_he_id}_${props.filter.dm_khoi_id}_${props.filter.dm_truong_id}_${props.filter.nam_hoc}_${props.nam_nhap_hoc}_${props.ts_hocsinh_id}`;
  }, [
    props.filter.dm_he_id,
    props.filter.dm_khoi_id,
    props.filter.dm_truong_id,
    props.filter.nam_hoc,
    props.nam_nhap_hoc,
    props.ts_hocsinh_id,
  ]);

  const handleReloadMucPhaiThuChiTiet = useCallback(async () => {
    if (props.sf_mucphaithu_id && props.sf_mucphaithu_id > 0) {
      const res = await mucPhaiThuChiTietApi.selectByMucPhaiThu(
        props.sf_mucphaithu_id
      );
      if (res?.is_success && Array.isArray(res.data)) {
        const khoanIds = res.data.map((x: any) => x.sf_khoannop_id);
        setKhoanDaNops(khoanIds);
      } else {
        setKhoanDaNops([]);
      }
      return;
    }
    const request = {
      nam_hoc: props.filter.nam_hoc,
      ts_hocsinh_id: props.ts_hocsinh_id,
    };
    const res = await mucPhaiThuChiTietApi.select_all_khoannop(request);
    if (res?.is_success && Array.isArray(res.data)) {
      const khoanDaNopIds = res.data.map((x: any) => x.sf_khoannop_id);
      setKhoanDaNops(khoanDaNopIds);
    } else {
      setKhoanDaNops([]);
    }
  }, [props.filter.nam_hoc, props.sf_mucphaithu_id, props.ts_hocsinh_id]);

  const handleReloadKhoanNop = useCallback(async () => {
    let isLoading = true;
    const intever_obj = setInterval(() => {
      if (!isLoading) {
        clearInterval(intever_obj);
      }
    }, 200);
    const datasend = {
      dm_he_id: props.filter.dm_he_id,
      dm_khoi_id: props.filter.dm_khoi_id,
      dm_truong_id: props.filter.dm_truong_id,
      nam_hoc: props.filter.nam_hoc,
      nam_nhap_hoc:
        props.nam_nhap_hoc === undefined
          ? props.filter.nam_hoc
          : props.nam_nhap_hoc,
    };
    const res = await mucThuPhiApi.select_by_nam_nhap_hoc(datasend);
    if (res.is_success) {
      let sf_mucthuphi_datasource = res.data
        .filter((x: any) => {
          // Nếu nam_nhap_hoc được truyền vào, chỉ lấy những khoản nộp có nam_nhap_hoc khớp
          // Nếu không có nam_nhap_hoc, lấy tất cả dữ liệu từ API
          if (
            props.nam_nhap_hoc !== undefined &&
            props.nam_nhap_hoc !== null &&
            props.nam_nhap_hoc !== ""
          ) {
            return x.nam_nhap_hoc === props.nam_nhap_hoc;
          }
          return true;
        })
        .map((x: any) => {
          return {
            ...x,
            so_tien_phai_nop: x.so_tien,
            ghi_chu: "",
          };
        });
      if (props.sf_khoannop_ids_added) {
        sf_mucthuphi_datasource = sf_mucthuphi_datasource.filter(
          (x: any) =>
            props.sf_khoannop_ids_added === undefined ||
            !props.sf_khoannop_ids_added.includes(x.sf_khoannop_id)
        );
      }
      setOriginalDataSource(sf_mucthuphi_datasource);
    }
    handleReloadMucPhaiThuChiTiet();
    isLoading = false;
  }, [
    props.filter.dm_he_id,
    props.filter.dm_khoi_id,
    props.filter.dm_truong_id,
    props.filter.nam_hoc,
    props.nam_nhap_hoc,
    props.sf_khoannop_ids_added,
    handleReloadMucPhaiThuChiTiet,
  ]);

  useEffect(() => {
    handleReloadKhoanNop();
  }, [filterKey, handleReloadKhoanNop]);

  const raw_data_source = useMemo(() => {
    return sf_mucthuphi_datasource.map((item) => ({
      ...item,
      so_tien_phai_nop: item.so_tien_phai_nop ?? item.so_tien ?? 0,
    }));
  }, [sf_mucthuphi_datasource]);

  const data_source = useMemo(() => {
    const getOrder = (item: any): { thuTuNhom: number; thuTu: number } => {
      return {
        thuTuNhom: Number(item.thutu_sapxep_nhomkhoannop) || 0,
        thuTu: Number(item.thutu_sapxep) || 0,
      };
    };
    const groupedData: Record<string, any[]> = {};
    raw_data_source.forEach((item: any) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }
      groupedData[groupKey].push(item);
    });

    // Flatten data with group headers
    const result: any[] = [];
    const sortedGroupKeys = Object.keys(groupedData).sort((a, b) => {
      const ordersA = groupedData[a].map(getOrder);
      const ordersB = groupedData[b].map(getOrder);

      const minNhomA = Math.min(...ordersA.map((o) => o.thuTuNhom));
      const minNhomB = Math.min(...ordersB.map((o) => o.thuTuNhom));
      if (minNhomA !== minNhomB) return minNhomA - minNhomB;

      const minThuTuA = Math.min(...ordersA.map((o) => o.thuTu));
      const minThuTuB = Math.min(...ordersB.map((o) => o.thuTu));
      if (minThuTuA !== minThuTuB) return minThuTuA - minThuTuB;

      return String(a).localeCompare(String(b), "vi");
    });

    sortedGroupKeys.forEach((groupKey) => {
      result.push({
        id: `group_${groupKey}`,
        isGroupHeader: true,
        nhom_khoan_nop: groupKey,
        ma_khoan_nop: "",
        ten_khoan_nop: `Nhóm: ${groupKey}`,
        groupItems: groupedData[groupKey],
        isExpanded: expandedGroups.has(groupKey),
      });

      if (expandedGroups.has(groupKey)) {
        const sortedItems = [...groupedData[groupKey]].sort((x: any, y: any) => {
          const a = getOrder(x);
          const b = getOrder(y);
          if (a.thuTu !== b.thuTu) return a.thuTu - b.thuTu;
          return String(x.ma_khoan_nop || "").localeCompare(
            String(y.ma_khoan_nop || ""),
            "vi"
          );
        });

        sortedItems.forEach((item) => {
          result.push({
            ...item,
            isGroupHeader: false,
            parentGroup: groupKey,
          });
        });
      }
    });

    return result;
  }, [raw_data_source, expandedGroups]);

  const uniqueGroupsStr = useMemo(() => {
    if (raw_data_source.length === 0) return "";
    const uniqueGroups = new Set<string>();
    raw_data_source.forEach((item) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      uniqueGroups.add(groupKey);
    });
    return Array.from(uniqueGroups).sort().join(",");
  }, [raw_data_source]);

  // Tự động expand tất cả groups khi có dữ liệu mới (chỉ khi groups thay đổi)
  useEffect(() => {
    if (!uniqueGroupsStr) return;

    setExpandedGroups((prev) => {
      const currentGroups = Array.from(prev.keys()).sort().join(",");
      if (currentGroups !== uniqueGroupsStr) {
        const newExpandedGroups = new Map<string, string>();
        uniqueGroupsStr.split(",").forEach((groupKey) => {
          newExpandedGroups.set(groupKey, groupKey);
        });
        return newExpandedGroups;
      }
      return prev;
    });
  }, [uniqueGroupsStr]);

  useEffect(() => {
    const totalAmount = raw_data_source
      .filter((x) => sf_mucthuphi_selected_ids.includes(x.id))
      .reduce((count, item) => {
        return (
          count +
          (item.so_tien_phai_nop === undefined || item.so_tien_phai_nop === 0
            ? item.so_tien
            : item.so_tien_phai_nop)
        );
      }, 0);
    setSummary(totalAmount);
  }, [sf_mucthuphi_selected_ids, raw_data_source]);

  const toggleGroup = useCallback((groupKey: string) => {
    setExpandedGroups((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(groupKey)) {
        newMap.delete(groupKey);
      } else {
        newMap.set(groupKey, groupKey);
      }
      return newMap;
    });
  }, []);

  const handleGroupSelection = useCallback(
    (groupKey: string, isSelected: boolean) => {
      const groupItems = raw_data_source.filter(
        (item) => (item.nhom_khoan_nop || "Khác") === groupKey
      );
      const groupItemIds = groupItems.map((item) => item.id);

      if (isSelected) {
        const newSelection = [...sf_mucthuphi_selected_ids];
        groupItemIds.forEach((id) => {
          if (!newSelection.includes(id)) {
            newSelection.push(id);
          }
        });
        set_sf_mucthuphi_selected_ids(newSelection);
      } else {
        const newSelection = sf_mucthuphi_selected_ids.filter(
          (id) => !groupItemIds.includes(id)
        );
        set_sf_mucthuphi_selected_ids(newSelection);
      }
    },
    [raw_data_source, sf_mucthuphi_selected_ids]
  );

  const handleItemSelection = useCallback(
    (itemId: number, isSelected: boolean) => {
      if (isSelected) {
        if (!sf_mucthuphi_selected_ids.includes(itemId)) {
          set_sf_mucthuphi_selected_ids([...sf_mucthuphi_selected_ids, itemId]);
        }
      } else {
        set_sf_mucthuphi_selected_ids(
          sf_mucthuphi_selected_ids.filter((id) => id !== itemId)
        );
      }
    },
    [sf_mucthuphi_selected_ids]
  );

  const handleSoTienChange = useCallback((rowId: number, value: number) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.so_tien_phai_nop === value) {
        return prev; // Không thay đổi, trả về cùng reference
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, so_tien_phai_nop: value };
        }
        return x;
      });
    });
  }, []);

  const handleGhiChuChange = useCallback((rowId: number, value: string) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.ghi_chu === value) {
        return prev; // Không thay đổi, trả về cùng reference
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, ghi_chu: value };
        }
        return x;
      });
    });
  }, []);

  const handelSubmit = () => {
    const data = {
      sf_bom_id: 0,
      is_calculate_miengiam: is_tinh_mien_giam,
      sf_bom_chitiets: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_mucthuphis: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_hinhthucnopbom_id:
        hinhThucNopBoms.length > 0 &&
          hinhThucNopBoms[0] !== undefined &&
          hinhThucNopBoms[0] !== null
          ? hinhThucNopBoms[0].id
          : 0,
    };
    props.onSelected(data);
    handleReloadMucPhaiThuChiTiet();
  };

  const columns = useMemo(() => {
    const result: IDataGridColumn[] = [
      {
        caption: "Tên khoản nộp",
        id: "ten_khoan_nop",
        dataField: "ten_khoan_nop",
        width: 250,
        align: "left",
        cellRender: (data: any) => {
          const isExpanded = expandedGroups.has(data.nhom_khoan_nop || "Khác");
          const level = data.isGroupHeader ? 0 : 1;
          const isGroup = data.isGroupHeader;

          if (isGroup) {
            const groupKey = data.nhom_khoan_nop || "Khác";
            const groupItems = raw_data_source.filter(
              (item) => (item.nhom_khoan_nop || "Khác") === groupKey
            );
            const groupItemIds = groupItems.map((item) => item.id);
            const isAllSelected =
              groupItemIds.length > 0 &&
              groupItemIds.every((id) =>
                sf_mucthuphi_selected_ids.includes(id)
              );
            const isPartialSelected = groupItemIds.some((id) =>
              sf_mucthuphi_selected_ids.includes(id)
            );

            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <IconButton
                  icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                  aria-label=""
                  variant="invisible"
                  size="small"
                  onClick={() => toggleGroup(groupKey)}
                />
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={isPartialSelected && !isAllSelected}
                  onChange={(e) =>
                    handleGroupSelection(groupKey, e.target.checked)
                  }
                />
                <Box
                  sx={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    color: "#0969da",
                  }}
                >
                  Nhóm: {groupKey}
                </Box>
              </Box>
            );
          } else {
            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <Checkbox
                  checked={sf_mucthuphi_selected_ids.includes(data.id)}
                  onChange={(e) =>
                    handleItemSelection(data.id, e.target.checked)
                  }
                />
                <Box sx={{ marginLeft: "8px" }}>
                  <TextWithEllipse
                    text={data.ten_khoan_nop || ""}
                    lineNumber={2}
                  />
                </Box>
              </Box>
            );
          }
        },
      },
      {
        caption: "Mã khoản nộp",
        id: "ma_khoan_nop",
        dataField: "ma_khoan_nop",
        width: 150,
        align: "left",
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          return (
            <TextWithEllipse text={data.ma_khoan_nop || ""} lineNumber={1} />
          );
        },
      },
      // {
      //   caption: "Số tiền định mức",
      //   id: "so_tien",
      //   dataField: "so_tien",
      //   width: 150,
      //   align: "right",
      //   isAllowFocus: false,
      //   cellRender: (data: any) => {
      //     if (data.isGroupHeader) {
      //       return <span></span>;
      //     }
      //     return (
      //       <div style={{ textAlign: "right" }}>
      //         {formatVND(data.so_tien || 0)}
      //       </div>
      //     );
      //   },
      // },
      {
        caption: "Số tiền phải nộp",
        id: "so_tien_phai_nop",
        dataField: "so_tien_phai_nop",
        width: 150,
        align: "right",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.so_tien_phai_nop || 0;
          const rowId = data.id;
          return (
            <Box
              sx={{
                width: "100%",
                textAlign: "right",
                "& .dx-texteditor-input": {
                  textAlign: "right",
                },
              }}
            >
              <NumberBox
                value={value}
                format="#,##0"
                width="100%"
                stylingMode="outlined"
                onValueChanged={(e) => {
                  if (
                    e.value !== null &&
                    e.value !== undefined &&
                    e.value !== value
                  ) {
                    handleSoTienChange(rowId, e.value);
                  }
                }}
              />
            </Box>
          );
        },
      },
      {
        caption: "Ghi chú",
        id: "ghi_chu",
        dataField: "ghi_chu",
        width: 250,
        align: "left",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.ghi_chu || "";
          const rowId = data.id;
          return (
            <Box sx={{ width: "100%" }}>
              <TextInput
                value={value}
                onChange={(e) => {
                  if (e.target.value !== value) {
                    handleGhiChuChange(rowId, e.target.value);
                  }
                }}
                sx={{ width: "100%" }}
              />
            </Box>
          );
        },
      },
    ];

    return result;
  }, [
    expandedGroups,
    sf_mucthuphi_selected_ids,
    raw_data_source,
    toggleGroup,
    handleGroupSelection,
    handleItemSelection,
    handleSoTienChange,
    handleGhiChuChange,
  ]);

  return (
    <DefaultPopup width="80%" title={"Thêm khoản nộp"} onClose={props.onCancel}>
      <div>
        <div>
          <div className="row">
            <div className="col-md-12">
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <Text
                  text="Danh sách khoản nộp"
                  sx={{ fontSize: 16, fontWeight: 600 }}
                />

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <CmbHinhThucNopBom
                    isShowClearButton={true}
                    size="small"
                    width={200}
                    stylingMode="filled"
                    sf_hinhthucnopbom_dotgui={props.sf_hinhthucnopbom_ids}
                    value={
                      hinhThucNopBoms &&
                        hinhThucNopBoms.length > 0 &&
                        hinhThucNopBoms[0]
                        ? hinhThucNopBoms[0].id
                        : undefined
                    }
                    onValueChanged={(_id, data) => {
                      if (data) {
                        setHinhThucNopBoms([data]);
                      }
                    }}
                    dmCoSoId={dm_coso_id}
                  />
                  <Box sx={{ width: 220 }}>
                    <SelectBoxMultipleKhomKhoanNop
                      width="100%"
                      size="small"
                      isShowClearBtn
                      value={selectedNhomKhoanNopIds}
                      onValueChanged={(ids) => {
                        const safeIds = ids || [];
                        setSelectedNhomKhoanNopIds(safeIds);
                        const names =
                          sf_nhomkhoannops
                            ?.filter((x) => safeIds.includes(x.id))
                            .map((x) => x.nhom_khoan_nop)
                            .filter(Boolean) || [];
                        setSelectedNhomKhoanNopNames(names as string[]);
                      }}
                    />
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <label className="form-label">
                      Tổng tiền phải nộp:{" "}
                      <span style={{ color: "red", fontWeight: 600 }}>
                        {summary?.toLocaleString()}
                      </span>{" "}
                      VNĐ
                    </label>
                  </Box>
                </Box>

                <DataGrid
                  dataSource={data_source}
                  columns={columns as any}
                  height={window.innerHeight - 300}
                  isLoading={false}
                  paging={{ enable: false }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalActions>
        <Button
          variant="default"
          leadingVisual={XIcon}
          text="Đóng"
          onClick={() => {
            props.onCancel();
          }}
        />
        <Button
          variant="primary"
          leadingVisual={CheckIcon}
          text="Bổ sung"
          isLoading={props.isSaving}
          disabled={sf_mucthuphi_selected_ids.length === 0}
          onClick={handelSubmit}
        />
      </ModalActions>
    </DefaultPopup>
  );
};
